// @flow

/*
 * FIXME: eslint reports duplicate exports because of how we handle hybrid TS/Flow packages currently.
 * Once this package is entirely converted to TS, we can re-enable the import/export rule
 */
/* eslint-disable import/export */

export * from './index.ts';

// Form Components
export {
  default as BooleanInput,
  Checkbox,
  Radio,
  LabeledCheckbox,
  LabeledRadio,
} from './components/forms/BooleanInput';
export { default as Dropdown } from './components/forms/Dropdown';
export type { DropdownProps } from './components/forms/Dropdown';
export { default as Field } from './components/forms/Field';
export type * from './components/forms/Field';
export {
  default as FormLabel,
  FormLabelRequiredText,
} from './components/forms/FormLabel';
export { default as FloatingMenu } from './components/forms/FloatingMenu';
export type {
  FloatingMenuGetLabelForItem,
  FloatingMenuItem,
} from './components/forms/FloatingMenu';
export { default as Input } from './components/forms/Input';
export type { InputProps } from './components/forms/Input';
export { default as Menu, MenuItem } from './components/forms/Menu';
export { default as TextInput } from './components/forms/TextInput';
export type * from './components/forms/TextInput';
export { default as ToggleSwitch } from './components/forms/ToggleSwitch';

// Navigation Components
export {
  default as Button,
  ButtonColors as DefaultButtonColors,
} from './components/navigation/Button';
export type * from './components/navigation/Button';
export { default as ButtonNav } from './components/navigation/ButtonNav';
export type {
  ButtonNavItemType,
  ButtonNavOnChooseItem,
} from './components/navigation/ButtonNav/types';
export { default as IconButton } from './components/navigation/IconButton';
export {
  default as Paginator,
  PaginatorStateful,
} from './components/navigation/Paginator';
export type { OnPaginateData } from './components/navigation/Paginator';
export { default as Nav, AutoNav } from './components/navigation/Nav';
export type * from './components/navigation/Nav/types';

export * from './flow-types.js';
